// @flow
import React from "react";

type IconProps = {
	// a Lucide icon component, e.g. ShoppingBag from "lucide-react"
	icon: any,
	size?: number,
	className?: string,
	// a filled shape - the chosen bookmark, say - instead of the outline
	filled?: boolean,
};

/**
 * An icon of the Lucide set as the module draws it. It takes the colour of the text around it, so a
 * theme sets one colour instead of a file per brand. Its size and fill are set inline: the dealer's
 * page may size or fill every svg of its own, and an inline style is what such a rule does not reach.
 * Screen readers skip it; the control that holds it names what it does.
 */
const Icon = ({icon: Glyph, size = 20, className = "", filled = false}: IconProps) =>
	<Glyph size={size} strokeWidth={1.75} aria-hidden="true" focusable="false"
		   className={`hpm-icon ${className}`.trim()}
		   style={{width: size, height: size, flex: "none", fill: filled ? "currentColor" : "none"}}/>;

export default Icon;
